import React from 'react';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';

import * as actions from 'containers/Settings/Leads/actions';
import { Loading } from 'components/Loading';
import Card from 'components/Cards/OrgMemberCard';

const DefaultAssignment = () => {
  const defaultAssignments = useSelector(state => state.settings.leadSettings.defaultAssignments);
  const items = defaultAssignments.map(item => ({ ...item, checked: item.isDefaultLeadAssignment }));
  const assignedUsers = defaultAssignments.filter(item => item.isDefaultLeadAssignment);
  const loaded = useSelector(state => state.settings.leadSettings.isDefaultAssignmentLoaded);

  const dispatch = useDispatch();
  const { setDefaultAssignment, unsetDefaultAssignment } = bindActionCreators(actions, dispatch);

  const setDefaultLeadAssignment = ({ loginId, orgId }) => {
    setDefaultAssignment({ loginId, orgId });
  };

  const unsetDefaultLeadAssignment = ({ loginId, orgId }) => {
    unsetDefaultAssignment({ loginId, orgId });
  };

  return (
    <>
      <p className="lead-setting__intro">
        Select the team members who will automatically be assigned to all new leads.
        You can always reassign new leads from within each lead record.{' '}
        <a
          href="https://help.aisleplanner.com/en/articles/2324391-setting-default-lead-assignments"
          target="_blank"
          rel="noreferrer"
        >
          Learn more here
        </a>
        .
      </p>
      <div className={clsx('lead-setting__status-list', 'row', !loaded && 'loading')}>
        {!loaded ? (
          <Loading />
        ) : items.map((item, index) => (
          <Card
            key={`modal-card__${index}`}
            {...item}
            setMember={setDefaultLeadAssignment}
            unsetMember={unsetDefaultLeadAssignment}
          />
        ))}
      </div>
      {!assignedUsers.length && (
        <p className="lead-setting__warning">
          We noticed you've removed all default assignments.
          We recommend assigning at least one team member to help you stay on top of new leads.
        </p>
      )}
    </>
  );
};

export default DefaultAssignment;
